import { useQuery } from '@tanstack/react-query'
import { getApi } from '@BUP/services/Axios'

const fetchCurrentTerm = async () => {
  const client = await getApi('schools', { version: 3 })
  const { data } = await client.get('current-organization/current-term')
  return data
}

export const useGetCurrentTerm = () => {
  return useQuery({
    queryKey: ['current-term'],
    queryFn: fetchCurrentTerm,
    staleTime: 1000 * 60 * 10, // 10 minutos
    retry: 1
  })
}
